export default "__VITE_ASSET__DlV50zFH__"